<!--
  - Copyright (c) 2020 brightlamp
  -->

<template>
    <div>
        <v-container>
            <v-row align="center" justify="center">
                <v-col xs="12" sm="8" md="8" lg="6">
                    <v-card>
                        <v-progress-linear v-if="waiting" :indeterminate="true"/>
                        <v-card-title>
                            <span class="headline" align="center" style="color:#FFFD00;background-color:#000000;width:100%;display:block;">{{`Stripe Billing ${currentUser && currentUser.orgId != null ? 'For Your Org' : 'For You'}`}}</span>
                        </v-card-title>
                        <v-subheader>
                            <span>Subscription</span>
                        </v-subheader>
                        <v-container>
                            <v-card flat outlined>
                                <v-card-text class="d-flex flex-wrap font-weight-black">
                                    {{`Current Products: ${paymentInfo.subscription ? paymentInfo.subscription.names : 'None'}`}}
                                </v-card-text>
                                <v-card-text class="mt-n6 d-flex flex-wrap font-weight-black">
                                    {{`${paymentInfo.subscription && paymentInfo.subscription.canceledDate ? 'Subscription Ends' : 'Next Billing'}: ${paymentInfo.subscription ? new Date(paymentInfo.subscription.currentPeriodEnd).toLocaleString().split((','))[0] : "N/A"}`}}
                                </v-card-text>
                                <v-card-text class="d-flex flex-wrap">
                                    <v-btn :disabled="!currentUser || currentUser.orgId != null" small color="yellow" depressed @click="requestAlterSubscription">
                                        <v-icon left>mdi-file-replace-outline</v-icon>
                                        Request/Alter Subscription
                                    </v-btn>
                                    <div class="break"></div>
                                    <v-btn small color="yellow" depressed @click="requestCancelSubscription" :disabled="!currentUser || currentUser.orgId != null || !paymentInfo.subscription || paymentInfo.subscription.canceledDate != null">
                                        <v-icon left>mdi-cancel</v-icon>
                                        Cancel
                                    </v-btn>
                                </v-card-text>
                            </v-card>
                        </v-container>
<!--                        <v-row justify="center">-->
<!--                            <v-col md="6">-->
<!--                                <div class="mx-4" id="wallet-pay-button" ref="wallet-pay-button"></div>-->
<!--                            </v-col>-->
<!--                        </v-row>-->
                        <v-subheader>
                            <span>Cards</span>
                            <v-spacer/>
                            <v-btn small color="yellow" depressed @click="addCreditCard = true" :disabled="!currentUser || (currentUser.orgId != null && !isOrgAdmin)">
                                <v-icon left>mdi-credit-card-plus</v-icon>
                                Add
                            </v-btn>
                        </v-subheader>
                        <v-list>
                            <template v-for="(card, cardIndex) in paymentInfo.cards">
                                <template v-if="card.brand">
                                    <v-container>
                                        <v-row>
                                            <v-col xs="12">
                                                <v-card :class="{'mt-n8' : cardIndex !== 0}" flat outlined>
                                                    <template v-if="card.defaultCard">
                                                    <v-container>
                                                        <v-row>
                                                            <v-card flat class="mb-n6">
                                                                <v-chip class="ml-2" color="blue lighten-3" x-small text-color="deep-purple">Default</v-chip>
                                                            </v-card>
                                                        </v-row>
                                                    </v-container>
                                                    </template>
                                                    <v-card-actions>
                                                        <v-avatar>
                                                            <v-img width="64" height="36" :src="require(`@/assets/images/${card.brand.toLowerCase()}.svg`)"/>
                                                        </v-avatar>
                                                        <span class="ma-2">{{`•••• ${card.last4}`}}</span><span class="ma-2">{{`${String(card.expMonth).padStart(2, '0')}/${card.expYear}`}}</span>
                                                        <v-spacer/>
                                                        <v-menu bottom right offset-y>
                                                            <template v-slot:activator="{on}">
                                                                <v-btn depressed v-on="on">
                                                                    <v-icon>mdi-dots-horizontal</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-list>
                                                                <v-list-item v-for="(command, commandIndex) in commands" v-bind:key="commandIndex" :disabled="(paymentInfo.cards.length < 2 && commandIndex === 1) || (card.defaultCard && commandIndex === 2)" @click="command.action(commandIndex, cardIndex)">
                                                                    <v-list-item-icon>
                                                                        <v-icon v-text="command.icon"></v-icon>
                                                                    </v-list-item-icon>
                                                                    <v-list-item-title>{{command.title}}</v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </template>
                            </template>
                        </v-list>
                        <template v-if="showTelehealthInfo">
                            <v-subheader>
                                <span>Telehealth</span>
                            </v-subheader>
                            <v-container>
                                <v-row >
                                    <v-col xs="12">
                                        <v-card class="mt-n4" flat outlined>
                                            <v-card-text class="font-weight-black">
                                                {{`Test Requests Billed For This Period: ${orgTestRequestCount}`}}
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>
                        <v-col>
                            <p><a href="https://reflexapp.io/contact/" target="_blank">Have a billing question?</a></p>
                            <div>
                                <v-img  class="mx-auto" width="174" height="30" :src="require('@/assets/images/powered_by_stripe.svg')"/>
                                <v-card class="mt-2" flat outlined>
                                    <v-card-text class="tos">
                                        <span >Your subscription will be charged to your default credit card on file. At the end of the term, unless you cancel, your subscription will automatically renew.
                                            You will be charged for the regular price of your subscription within 24 hours prior to the end of the current term. You can turn off automatic renewal at any time,
                                            but you must do so at least 24 hours before the end of the current term. Refunds will not be provided for the unused portion of any term. For more information, please
                                            visit our <a href="https://reflexapp.io/terms-conditions/#cancellation_policy" target="_blank">Terms + Conditions</a>.</span>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </v-col>
                    </v-card>
                </v-col>
            </v-row>
            <template v-if="currentUser && !currentUser.orgId && (!currentUser.overrideSubscription || currentUser.overrideSubscription && new Date(currentUser.overrideSubscription) < new Date()) && currentUser.appleSubscription && ('1' === currentUser.appleSubscription.subscriberLevel || '2' === currentUser.appleSubscription.subscriberLevel || '3' === currentUser.appleSubscription.subscriberLevel || '1e' === currentUser.appleSubscription.subscriberLevel || '2e' === currentUser.appleSubscription.subscriberLevel || '3e' === currentUser.appleSubscription.subscriberLevel)">
                <v-row align="center" justify="center">
                    <v-col xs="12" sm="8" md="8" lg="6">
                        <v-card>
                            <v-card-title>
                                <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Apple Billing For You</span>
                            </v-card-title>
                            <v-subheader>
                                <span>Subscription</span>
                            </v-subheader>
                            <v-container>
                                <v-card flat outlined>
                                    <v-card-text class="d-flex flex-wrap font-weight-black">
                                        {{`${new Date() > new Date(currentUser.appleSubscription.expiresDate) ? 'Expired' : 'Current'} Plan: ${currentUser.appleSubscription.productId}`}}
                                        <div class="break"></div>
                                        {{`Next Billing: ${new Date() > new Date(currentUser.appleSubscription.expiresDate) ? 'Expired' : new Date(currentUser.appleSubscription.expiresDate).toLocaleString().split((','))[0]}`}}
                                    </v-card-text>
                                    <div class="ma-4">
                                        <span><a href="https://apps.apple.com/account/billing" target="_blank">Apple Billing Info</a></span>
                                        <span class="ml-4"><a href="https://apps.apple.com/account/subscriptions" target="_blank">Apple Subscription</a></span>
                                    </div>
                                </v-card>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
        </v-container>
        <AddCreditCardDialog v-if="addCreditCard" :forOrg="currentUser.orgId" @add-credit-card-dialog-response="cardAddedResponse"></AddCreditCardDialog>
        <EditCreditCardDialog v-if="editCreditCard" :forOrg="currentUser.orgId" :cardIndex="currentCardIndex" @edit-credit-card-dialog-response="cardEditResponse"></EditCreditCardDialog>
        <RemoveCreditCardDialog v-if="removeCreditCard" :forOrg="currentUser.orgId" :cardIndex="currentCardIndex" @remove-credit-card-dialog-response="cardRemoveResponse"></RemoveCreditCardDialog>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import AddCreditCardDialog from '@/components/add-credit-card-dialog'
    import EditCreditCardDialog from '@/components/edit-credit-card-dialog'
    import RemoveCreditCardDialog from '@/components/remove-credit-card-dialog'

    export default
    {
        name: 'user-billing-tab',
        components:
        {
            AddCreditCardDialog,
            EditCreditCardDialog,
            RemoveCreditCardDialog,
        },
        data: function ()
        {
            return {
                currentCardIndex: 0,
                commands:
                [
                    {
                        title: 'Edit',
                        icon: 'mdi-credit-card-settings',
                        action: this.commandSelected
                    },
                    {
                        title: 'Remove',
                        icon: 'mdi-credit-card-off',
                        action: this.commandSelected
                    },
                    {
                        title: 'Set as Default',
                        icon: 'mdi-credit-card-marker',
                        action: this.commandSelected
                    }
                ],
                addCreditCard: false,
                editCreditCard: false,
                removeCreditCard: false,
                // paymentRequest: {},
                showTelehealthInfo: false
            }
        },
        async mounted()
        {
            await this.getPaymentInfo();
            await this.setUpStripe();
            await this.getOrgTestRequestCount()
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser
            }),
            ...mapState('customerBilling',
            {
                paymentInfo: state => state.paymentInfo,
                orgTestRequestCount: state => state.orgTestRequestCount
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            }),
            isNotOrgAdmin()
            {
                return !this.currentUser.orgId || (this.currentUser.authorities && this.currentUser.authorities[0].role === 'ROLE_USER')
            },
            isOrgAdmin()
            {
                return this.currentUser.orgId && this.currentUser.authorities && (this.currentUser.authorities[0].role === 'ROLE_ORG_ADMIN' || this.currentUser.authorities[0].role === 'ROLE_ADMIN')
            }
        },
        methods:
        {
            ...mapActions('auth', ['FETCH_AUTH']),
            ...mapMutations('auth', ['SET_CURRENT_USER']),
            ...mapActions('customerBilling', ['GET_PAYMENT_INFO', 'SET_PAYMENT_INFO', 'GET_ORG_PAYMENT_INFO', 'SET_ORG_PAYMENT_INFO', 'GET_TEST_REQUEST_COUNT_FOR_CURRENT_PERIOD']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            requestAlterSubscription()
            {
                window.open('https://reflexapp.io/subscribe/', '_blank')
            },
            requestCancelSubscription()
            {
                window.open('https://reflexapp.io/cancel/', '_blank')
            },
            async commandSelected(commandIndex, cardIndex)
            {
                this.currentCardIndex = cardIndex;
                // If the edit command was selected
                if (0 === commandIndex)
                {
                    this.editCreditCard = true
                }
                // If the remove command was selected
                else if (1 === commandIndex)
                {
                    this.removeCreditCard = true
                }
                else // Else the set as default command was selected
                {
                    try
                    {
                        this.HIDE_SNACKBAR();
                        this.WAITING(true);
                        this.paymentInfo.cards[cardIndex].defaultCard = true;

                        // If this is non-org user, set their own payment info
                        if (!this.currentUser.orgId)
                        {
                            await this.SET_PAYMENT_INFO(this.paymentInfo)
                        }
                        // Else this is an org admin or admin, set the org's payment info (not allowed to change the plan)
                        else if (this.currentUser.authorities && (this.currentUser.authorities[0].role === 'ROLE_ORG_ADMIN' || this.currentUser.authorities[0].role === 'ROLE_ADMIN'))
                        {
                            await this.SET_ORG_PAYMENT_INFO({orgId: this.currentUser.orgId, data: this.paymentInfo})
                        }
                        this.WAITING(false)
                    }
                    catch (error)
                    {
                        this.SHOW_SNACKBAR_ERROR(error.response && error.response.data && error.response.data.reason ? error.response.data.reason : error.message);
                        this.WAITING(false);
                        await this.getPaymentInfo()
                    }
                }
            },
            async cardAddedResponse(payload)
            {
                this.addCreditCard = false;
                if (payload)
                {
                    await this.getPaymentInfo()
                }
            },
            async cardEditResponse(payload)
            {
                this.editCreditCard = false;
                if (payload)
                {
                    await this.getPaymentInfo()
                }
            },
            async cardRemoveResponse(payload)
            {
                this.removeCreditCard = false;
                if (payload)
                {
                    await this.getPaymentInfo()
                }
            },
            async setUpStripe()
            {
                if (window.Stripe === undefined)
                {
                    this.SHOW_SNACKBAR_ERROR('Stripe V3 library not loaded!')
                }
                else
                {
                    /*eslint-disable */
                    this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY, {apiVersion: '2023-08-16'});
                    /*eslint-enable */
            //         const elements = this.stripe.elements();
            //
            //         this.paymentRequest = this.stripe.paymentRequest(
            //         {
            //             country: 'US',
            //             currency: 'usd',
            //             total:
            //             {
            //                 label: 'Reflex Subscription',
            //                 amount: 100
            //             },
            //             requestPayerName: true,
            //             requestPayerEmail: true
            //         });
            //
            //         this.walletButton = elements.create('paymentRequestButton', { paymentRequest: this.paymentRequest });
            //
            //         await (async () =>
            //         {
            //             // Check the availability of the Payment Request API first
            //             const result = await this.paymentRequest.canMakePayment();
            //             if (result)
            //             {
            //                 this.walletButton.mount(this.$refs['wallet-pay-button'])
            //             }
            //             else
            //             {
            //                 document.getElementById('wallet-pay-button').style.display = 'none'
            //             }
            //         })();
            //
            //         this.paymentRequest.on('token', async (event) =>
            //         {
            //             try
            //             {
            //                 this.paymentInfo.cards.push({cardToken: event.token.id});
            //                 await this.SET_PAYMENT_INFO(this.paymentInfo)
            //             }
            //             catch (error)
            //             {
            //                 this.SHOW_SNACKBAR_ERROR(error.response && error.response.data && error.response.data.reason ? error.response.data.reason : error.message)
            //             }
            //             this.WAITING(false);
            //             event.complete('success')
            //         });
                }
            },
            async getPaymentInfo()
            {
                try
                {
                    this.WAITING(true);
                    // If this is non-org user, pull their own payment info
                    if (!this.currentUser.orgId)
                    {
                        await this.GET_PAYMENT_INFO()
                    }
                    // Else this is an org admin or admin, pull the org's payment info
                    else if (this.currentUser.authorities && (this.currentUser.authorities[0].role === 'ROLE_ORG_ADMIN' || this.currentUser.authorities[0].role === 'ROLE_ADMIN'))
                    {
                        await this.GET_ORG_PAYMENT_INFO(this.currentUser.orgId)
                    }
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.response && error.response.data && error.response.data.reason ? error.response.data.reason : error.message)
                }
                this.WAITING(false)
            },
            async getOrgTestRequestCount()
            {
                try
                {
                    // If the user belongs to an org, pull the number of test requests for the current billing period
                    if (this.currentUser.orgId)
                    {
                        this.HIDE_SNACKBAR();
                        this.WAITING(true);
                        await this.GET_TEST_REQUEST_COUNT_FOR_CURRENT_PERIOD();
                        this.showTelehealthInfo = true
                    }
                }
                catch (error)
                {
                    this.showTelehealthInfo = false;
                    if (error.response.status !== 404)
                    {
                        this.SHOW_SNACKBAR_ERROR(error.response && error.response.data && error.response.data.reason ? error.response.data.reason : error.message)
                    }
                }
                this.WAITING(false)
            }
        }
    };
</script>

<style scoped>
    .break {
        flex: 1 1 auto;
        height: 0;
    }
    .tos {
        font-size: 9px;
        line-height: 1.5;
        font-weight: bold;
    }
</style>